import React, { Fragment, memo, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import {
  setCreatePostState,
  clearCreatePost,
} from 'modules/createPost/createPost.actions';
import { Row, BodyText, LinkFont, Button } from 'modules/styled';
import { useCreatePost } from './hooks';

const CHAT_ENABLED = false;

export default memo(Footer);

Footer.propTypes = {
  close: PropTypes.func,
};

function Footer({ close }) {
  const dispatch = useDispatch();
  const [{ submitting }, setStatus] = useState({ submitting: false, error: null });
  const user = useSelector((state) => state.auth.user);
  const postData = useSelector((state) => state.createPost);
  const { channel, postBody, edit, selectedTags } = postData;

  const handleCheckbox = (e) => setState({ [e.target.name]: e.target.checked });

  const clearPost = useCallback(() => dispatch(clearCreatePost()), [dispatch]);

  const createPost = useCreatePost({ close, clearPost, setStatus });

  const setState = (state) =>
    dispatch(
      setCreatePostState({
        ...postData,
        ...state,
      })
    );

  const submitDisabled =
    submitting || !selectedTags.length || !postBody || !postBody.trim().length;
  const isAdmin = user && user.role === 'admin';

  return (
    <Fragment>
      <Row sx={{ mt: 2, justifyContent: 'space-between' }}>
        {isAdmin && CHAT_ENABLED && (
          <Row sx={{ alignItems: 'center', alignSelf: 'center' }}>
            <input
              checked={channel}
              type="checkbox"
              name={'channel'}
              onChange={handleCheckbox}
            />
            <BodyText ml={0.5}>This is a chat channel</BodyText>
          </Row>
        )}
        <Row sx={{ flex: 1, justifyContent: 'flex-end', alignItems: 'center' }}>
          <LinkFont sx={{ mr: 2 }} onClick={clearPost}>
            Clear
          </LinkFont>

          <Button
            onPress={() => !submitDisabled && createPost(postData)}
            disabled={submitDisabled}
          >
            {edit ? 'Update Post' : 'Create Post'}
          </Button>
        </Row>
      </Row>
    </Fragment>
  );
}
